import type { FunctionComponent } from 'react'

import { usePageProps } from '../../usePageProps'
import { ResubscribeBanner } from '../ResubscribeBanner/ResubscribeBanner'

type ResubscribeBannerWrapperProps = {
  showBanner?: boolean
}

export const ResubscribeBannerWrapper: FunctionComponent<ResubscribeBannerWrapperProps> = ({
  showBanner,
}) => {
  const { userAccessState } = usePageProps()

  if (
    !showBanner ||
    !userAccessState?.transformTypeDecision ||
    userAccessState.transformTypeDecision !== 'AUTHENTICATED_NO_ACCESS'
  ) {
    return null
  }

  return <ResubscribeBanner showBanner={showBanner} />
}
